// extracted by mini-css-extract-plugin
export var quantityInput = "_gj-0";